// 表示文字列(日英対応)
export const languageType = {
  ja: 0,
  en: 1,
};

// 表示文字列(出力ファイル見出し)
export const reportFileLabel = ["診断レポート", "Diagnostic Report"];

// 表示文字列(所見欄)
export const reportOtherLabel = ["その他\n所見等", "Other\nFindings, etc."];

// 表示文字列(入力フォーム)
export const reportFormLabel = {
  createdDay: ["作成日", "Create Date"],
  companyName: ["会社名", "Name"],
  workNumber: ["工番", "MFG. No"],
  model: ["機種", "Type"],
  // 【"使用年数"&"機番" 非表示対応】graphqlはそのまま、画面表示からは対象外とする
  // useYears: ["使用年数", "Years of use"],
  // modelNumber: ["機番", "Machine Number"],
  dueDate: ["納入日", "MFG. Date"],
};

// 表示文字列(評価説明)
export const judgeLabel = {
  A: ["A：問題無し", "A：Normal"],
  B: ["B：注意・要観察", "B：Observe with caution"],
  C: ["C：警告・要点検整備", "C：Inspection required"],
};

// 表示文字列(TR用参考表)
export const trReferenceTableLabel = {
  motorType: ["モーター種類", "Motor type"],
  linear: ["リニア", "Linear"],
  rotary: ["回転系", "Rotary"],
  judge: ["判定", "Judgement"],
  A: ["A", "A"],
  B: ["B", "B"],
  C: ["C", "C"],
  linearTrErrorTempJudgeA: ["～ 1", "～ 1"],
  linearTrErrorTempJudgeB: ["2 ～", "2 ～"],
  linearTrErrorTempJudgeC: ["5 ～", "5 ～"],
  otherJudgeA: ["0 ～ 2", "0 ～ 2"],
  otherJudgeB: ["3 ～", "3 ～"],
  otherJudgeC: ["5 ～", "5 ～"],
};

// 診断カルテページで使用する色情報
export const reportTableColor = {
  currentData: "#daeef3",
  beforeData1: "#ebf1de",
  beforeData2: "#fde9d9",
  inputData: "#ffffcc",
  levelA: "#00b050",
  levelB: "#e46c0a",
  levelC: "#ff0000",
  default: "white",
};

export const targetData = {
  current: 0,
  before1: 1,
  before2: 2,
  refCurrent: 3,
  refBefore1: 4,
  refBefore2: 5,
};

export const pressType = {
  BL: "BL",
  TA: "TA",
  TR: "TR",
  TY: "TY",
  TS: "TS",
};

export const subTableType = {
  none: null,
  motor: "motor",
};

export const judgeList = [
  { value: "A.", label: "A." },
  { value: "B.", label: "B." },
  { value: "C.", label: "C." },
  { value: "-.", label: "-." },
  { value: ".", label: "　." },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "-", label: "-" },
  { value: "", label: "　" },
];

// 診断カルテ - ヘッダー情報
export const reportLabel = [
  {
    key: "item",
    label: ["項目", "Item"],
    align: "left",
    rowSpan: 1,
    colSpan: 3,
    color: reportTableColor.currentData,
  },
  {
    key: "currentData",
    label: ["今回の値(Y/M/D)\n(YYYY/MM/DD)", "This time(Y/M/D)\n(YYYY/MM/DD)"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.currentData,
  },
  {
    key: "currentDecision",
    label: ["判定", "Judgement"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.currentData,
  },
  {
    key: "beforeData1",
    label: ["前回の値(Y/M/D)\n(YYYY/MM/DD)", "Last time(Y/M/D)\n(YYYY/MM/DD)"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.beforeData1,
  },
  {
    key: "beforeDecision1",
    label: ["判定", "Judgement"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.beforeData1,
  },
  {
    key: "beforeData2",
    label: ["前々回の値(Y/M/D)\n(YYYY/MM/DD)", "Past(Y/M/D)\n(YYYY/MM/DD)"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.beforeData2,
  },
  {
    key: "beforeDecision2",
    label: ["判定", "Judgement"],
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.beforeData2,
  },
  {
    key: "note",
    label: ["備考", "Note"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.default,
  },
  {
    key: "explanation",
    label: ["説明と判定基準", "Description and Criteria"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    color: reportTableColor.default,
  },
];

// 診断カルテ - 判定用データ(共通部)
export const judgeDataALL = {
  dieHeightRange: {
    total: {
      lowerLimitA: 99,
      lowerLimitB: 100,
      lowerLimitC: 200,
      judgeDiff: false,
    },
  },
  dieHeightCount: {
    descent: {
      lowerLimitA: 1499999,
      lowerLimitB: 1500000,
      lowerLimitC: 2000000,
      judgeDiff: false,
    },
  },
  pointLeak: {
    all: {
      lowerLimitA: -0.9,
      lowerLimitB: -1.0,
      lowerLimitC: -1.5,
      judgeDiff: false,
    },
  },
};

// 診断カルテ - 判定用データ(BL)
export const judgeDataBL = {
  clutchTime: {
    total: {
      lowerLimitA: 449,
      lowerLimitB: 450,
      lowerLimitC: 500,
      judgeDiff: false,
    },
  },
  brakeTime: {
    total: {
      lowerLimitA: 449,
      lowerLimitB: 450,
      lowerLimitC: 500,
      judgeDiff: false,
    },
  },
  cfErrorTemp: {
    all: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  cfErrorElect: {
    all: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  plErrorTemp: {
    all: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  plErrorElect: {
    all: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
};

// 診断カルテ - 判定用データ(TA)
export const judgeDataTA = {
  clutchTime: {
    total: {
      lowerLimitA: 419,
      lowerLimitB: 420,
      lowerLimitC: 470,
      judgeDiff: false,
    },
  },
  brakeTime: {
    total: {
      lowerLimitA: 419,
      lowerLimitB: 420,
      lowerLimitC: 470,
      judgeDiff: false,
    },
  },
  rbMalfunction: {
    all: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
};

// 診断カルテ - 判定用データ(TR)
export const judgeDataTR = {
  clutchTime: {
    total: {
      lowerLimitA: 649,
      lowerLimitB: 650,
      lowerLimitC: 700,
      judgeDiff: false,
    },
  },
  brakeTime: {
    total: {
      lowerLimitA: 649,
      lowerLimitB: 650,
      lowerLimitC: 700,
      judgeDiff: false,
    },
  },
  trErrorTemp: {
    frontLinear1: {
      lowerLimitA: 1,
      lowerLimitB: 2,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    frontLinear2: {
      lowerLimitA: 1,
      lowerLimitB: 2,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    rearLinear1: {
      lowerLimitA: 1,
      lowerLimitB: 2,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    rearLinear2: {
      lowerLimitA: 1,
      lowerLimitB: 2,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  trErrorPosi: {
    frontFeed: {
      lowerLimitA: 2,
      lowerLimitB: 3,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    rearFeed: {
      lowerLimitA: 2,
      lowerLimitB: 3,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  trErrorElect: {
    frontFeed: {
      lowerLimitA: 2,
      lowerLimitB: 3,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    rearFeed: {
      lowerLimitA: 2,
      lowerLimitB: 3,
      lowerLimitC: 5,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
};

// 診断カルテ - 判定用データ(TS)
export const judgeDataTS = {
  clutchTime: {
    total: {
      lowerLimitA: 649,
      lowerLimitB: 650,
      lowerLimitC: 700,
      judgeDiff: false,
    },
  },
  brakeTime: {
    total: {
      lowerLimitA: 649,
      lowerLimitB: 650,
      lowerLimitC: 700,
      judgeDiff: false,
    },
  },
  trErrorTemp: {
    frontAmp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rearAmp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  trErrorPosi: {
    frontFeed: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rearFeed: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
  trErrorElect: {
    frontFeed: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rearFeed: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightLift: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    leftClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    rightClamp: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
    addAxis: {
      lowerLimitA: 0,
      lowerLimitB: 1,
      lowerLimitC: 3,
      judgeDiff: true,
    },
  },
};

// 診断カルテ - 判定用データ(TY)
export const judgeDataTY = {
  clutchTime: {
    total: {
      lowerLimitA: 419,
      lowerLimitB: 420,
      lowerLimitC: 470,
      judgeDiff: false,
    },
  },
  brakeTime: {
    total: {
      lowerLimitA: 419,
      lowerLimitB: 420,
      lowerLimitC: 470,
      judgeDiff: false,
    },
  },
  microInching: {
    magnet: {
      lowerLimitA: 899999,
      lowerLimitB: 900000,
      lowerLimitC: 1000000,
      judgeDiff: false,
    },
  },
};

// 診断カルテ - 診断用データ結合
export const getJudgeData = (type) => {
  let judgeData = null;

  switch (type) {
    case pressType.BL:
      judgeData = judgeDataBL;
      break;
    case pressType.TA:
      judgeData = judgeDataTA;
      break;
    case pressType.TR:
      judgeData = judgeDataTR;
      break;
    case pressType.TY:
      judgeData = judgeDataTY;
      break;
    case pressType.TS:
      judgeData = judgeDataTS;
      break;
    default:
      break;
  }
  return judgeData;
};

// 診断カルテ - 判定閾値取得
export const getJudgeInfo = (type, key, item) => {
  const judgeData = getJudgeData(type);

  if (judgeDataALL[key]) {
    const resultAll = { ...judgeDataALL[key] };
    if (resultAll.all) {
      return resultAll.all;
    }

    return resultAll[item];
  }

  if (judgeData) {
    const result = { ...judgeData[key] };
    if (result.all) {
      return result.all;
    }

    return result[item];
  }

  return null;
};

// 診断カルテ - 判定説明文リスト
export const descriptionList = {
  shotCount: {
    replace: false,
    grouping: false,
    decimal: false,
    explanation: [
      "生産数カウンタの値です\n判定なし",
      "The value of Production Counter.\nNo judgement",
    ],
  },
  dieHeightRange: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "スライド調整装置の走行距離です\nA：～{{judgeA}}m\nB：{{judgeB}}m～\nC：{{judgeC}}m～",
      "Traveling distance of slide adjustment device.\nA：～{{judgeA}} m\nB：{{judgeB}} m～\nC：{{judgeC}} m～",
    ],
  },
  dieHeightCount: {
    replace: true,
    grouping: true,
    decimal: false,
    explanation: [
      "スライド調整装置のON回数です\n電磁開閉器の点検指標です\nA：～{{judgeA}}回\nB：{{judgeB}}回～\nC：{{judgeC}}回～",
      "ON count of slide adjustment device.\nThis is an inspection index for electromagnetic switches.\nA：～{{judgeA}} times\nB：{{judgeB}} times～\nC：{{judgeC}} times～",
    ],
  },
  clutchTime: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "起動時間：信号ON～加速開始まで\n制動時間：加速開始～連結完了まで\nA：～{{judgeA}}ms\nB：{{judgeB}}ms～\nC：{{judgeC}}ms～",
      "Start Time:\nFrom signal ON to start of acceleration.\nConnect Time:\nFrom start of acceleration to completion of connection.\nA：～{{judgeA}} ms\nB：{{judgeB}} ms～\nC：{{judgeC}} ms～",
    ],
  },
  brakeTime: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "起動時間：信号ON～減速開始まで\n制動時間：減速開始～停止まで\n制動開始時のプレス速度(初速spm)により変化します\nA：～{{judgeA}}ms\nB：{{judgeB}}ms～\nC：{{judgeC}}ms～",
      "Start Time:\nFrom signal ON to start of deceleration.\nBrake Time:\nFrom start of deceleration to stop. \nIt varies depending on the press speed at the start of braking.\nA：～{{judgeA}} ms\nB：{{judgeB}} ms～\nC：{{judgeC}} ms～",
    ],
  },
  pointLeak: {
    replace: true,
    grouping: false,
    decimal: true,
    explanation: [
      "ﾎﾟﾝﾌﾟ停止30秒後のﾎﾟｲﾝﾄ圧低下量\nA：～{{judgeA}}MPa\nB：{{judgeB}}MPa～\nC：{{judgeC}}MPa～",
      "The amount of hydraulic pressure drop after 30 seconds of pump stoppage.\nA：～{{judgeA}} MPa\nB：{{judgeB}} MPa～\nC：{{judgeC}} MPa～",
    ],
  },
  cfErrorTemp: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "CFのモータの温度異常発生回数の4ケ月前の稼働日との差(増分)を表します\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "Number of temperature fault occurrence since the working day 4 months ago.\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
  cfErrorElect: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "CFのサーボモータの電流RMS値が設定値を超過した回数の4ケ月前の稼働日との差(増分)を表します\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "The number of times the RMS current value exceeds the set value since the working day 4 months ago.\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
  plErrorTemp: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "PLのモータの温度異常発生回数の4ケ月前の稼働日との差(増分)を表します\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "Number of temperature fault occurrence since the working day 4 months ago.\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
  plErrorElect: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "PLのサーボモータの電流RMS値が設定値を超過した回数の4ケ月前の稼働日との差(増分)を表します\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "The number of times the RMS current value exceeds the set value since the working day 4 months ago.\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
  coilRange: {
    replace: false,
    grouping: false,
    decimal: false,
    explanation: [
      "コイルの総通板長を表します\n判定なし",
      "Calculated value of coil total length of coil thread.\nNo judgement",
    ],
  },
  rbMalfunction: {
    replace: true,
    grouping: false,
    decimal: false,
    explanation: [
      "RB制御盤の重故障出力回数の4ケ月前の稼働日との差(増分)を表します\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "Number of times each RB control panel has output a major fault since the working day 4 months ago.\nA：{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
  trErrorTemp: {
    replace: false,
    grouping: false,
    decimal: false,
    explanation: [
      "TR装置各軸の温度異常発生回数の4ケ月前の稼働日との差(増分)を表します\n",
      "Number of warning occurrences for each axis since the working day 4 months ago.",
    ],
  },
  trErrorPosi: {
    replace: false,
    grouping: false,
    decimal: false,
    explanation: [
      "TR装置各軸の位置偏差警告発生回数の4ケ月前の稼働日との差(増分)を表します\n",
      "Number of warning occurrences for each axis since the working day 4 months ago.",
    ],
  },
  trErrorElect: {
    replace: false,
    grouping: false,
    decimal: false,
    explanation: [
      "TR装置のサーボ(リニア)モータのピーク電流が、サーボ(リニア)モータの電流値の仕様上限に到達した回数の4ケ月前の稼働日との差(増分)を表します\n",
      "The number of times the peak current has reached the limit of specification since the working day 4 months ago.",
    ],
  },
  microInching: {
    replace: true,
    grouping: true,
    decimal: false,
    explanation: [
      "マイクロインチングの総起動回数とマグネットスイッチの起動回数を表します\nA：～{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
      "The number of micro-inching device total activation, and magnet SW activation.\nA：～{{judgeA}}\nB：{{judgeB}}～\nC：{{judgeC}}～",
    ],
  },
};

// 診断カルテ - 所見欄用種別文リスト
export const otherReportKindsList = {
  trErrorTemp: [
    "No.7 TR軸警告数(温度異常)",
    "No.7 TR Axis Number of Warnings (Temp. Abnormal)",
  ],
  trErrorPosi: [
    "No.8 TR軸警告数(位置偏差)",
    "No.8 TR Axis Number of Warnings (Position Deviation)",
  ],
  trErrorElect: [
    "No.9 TRサーボモータピーク電流仕様上限 到達回数",
    "No.9 TR Servo Motor Peak Current Exceedance Count",
  ],
  rbMalfunction: ["No.7 RB重故障回数", "No.7 Number of RB Major Fault"],
  cfErrorTemp: [
    "No.7 CF警告数(温度異常)",
    "No.7 CF Number of Warnings (Temp. Abnormal)",
  ],
  cfErrorElect: [
    "No.8 CFｻｰﾎﾞﾓｰﾀ電流RMS値　設定値超過回数",
    "No.8 CF Servo Motor RMS Current Exceedance Count",
  ],
  plErrorTemp: ["No.9 PL警告数(温度異常)", "No.9 PL Number Of Warnings"],
  plErrorElect: [
    "No.10 PLｻｰﾎﾞﾓｰﾀ電流RMS値　設定値超過回数",
    "No.10 PL Servo Motor RMS Current Exceedance Count",
  ],
};

// 診断カルテ - 所見欄用部品文リスト
export const otherReportPartsList = {
  rightFront: ["右前", "Right Front"],
  leftFront: ["左前", "Left Front"],
  rightRear: ["右後", "Right Rear"],
  leftRear: ["左後", "Left Rear"],
  frontAmp: ["前フィード", "Front Feed"],
  frontFeed: ["前フィード", "Front Feed"],
  frontLinear1: ["前フィードリニア1", "Front Feed Linear 1"],
  frontLinear2: ["前フィードリニア2", "Front Feed Linear 2"],
  rearAmp: ["後フィード", "Rear Feed"],
  rearFeed: ["後フィード", "Rear Feed"],
  rearLinear1: ["後フィードリニア1", "Rear Feed Linear 1"],
  rearLinear2: ["後フィードリニア2", "Rear Feed Linear 2"],
  leftLift: ["左リフト", "Left Lift"],
  rightLift: ["右リフト", "Right Lift"],
  leftClamp: ["左クランプ", "Left Clamp"],
  rightClamp: ["右クランプ", "Right Clamp"],
  addAxis: ["追加軸", "Additional Axis"],
  df: ["DF RB", "DF RB"],
  ld: ["LD RB", "LD RB"],
  no1: ["No.1 RB", "No.1 RB"],
  no2: ["No.2 RB", "No.2 RB"],
  no3: ["No.3 RB", "No.3 RB"],
  ul: ["UL RB", "UL RB"],
  rollFeeder: ["ﾛｰﾙﾌｨｰﾀﾞ", "Roll Feeder"],
  terminalFeeder: ["端末フィーダ", "Coil End Feeder"],
  other: ["その他", "Other"],
  blank: ["ブランク材排出CV", "Blank Carry-out CV"],
  piler: ["パイラCV", "Piler CV"],
};

// 診断カルテ - 所見欄自動判定文リスト
export const otherReportList = {
  head: {
    value: "{{month}}月{{day}}日の所見\n{{month}} / {{day}} HF opinion",
  },
  headRef: {
    value:
      "{{month}}月{{day}}日の所見 / 今回の値の比較日 : ’{{refCurrentDateJp}}\n{{month}} / {{day}} HF opinion / Comparison dates of This time : ’{{refCurrentDateEn}}",
  },
  allA: {
    value:
      "特に異常は認められません。引き続き日常管理をお願いします。\nAll items are A. Please continue usual check.",
  },
  lastExistC: {
    value:
      "*予備品、消耗品の確認をお勧めします。弊社ｻｰﾋﾞｽへご相談ください。\n*Please check the spare parts & the consumable parts. Please contact HF service department.",
  },
  dieHeightRange: {
    B: "No.2 ﾀﾞｲﾊｲﾄ調整距離がB判定です。ポイントスキマや平行度など、点検を推奨します。\nNo.2 Die Height Adjustment Distance is B. Recommend inspection of the point clearance & the slide parallel to bolster ,etc.",
    C: "No.2 ﾀﾞｲﾊｲﾄ調整距離がC判定です。ポイントスキマや平行度など、点検をお願いします。\nNo.2 Die Height Adjustment Distance is C. Please inspect the point clearance & the slide parallel to bolster ,etc.",
  },
  dieHeightCount: {
    B: "No.3 ﾀﾞｲﾊｲﾄ調整回数がB判定です。異音、異常ﾒｯｾｰｼﾞなど、注意観察をお願いします。\nまた、電磁開閉器の交換を推奨します。\nNo.3 Die Height Adjustment Activation Count is B.\nPlease observe carefully the abnormal noise and the fault message , etc.\nAnd electromagnetic switch is recommended to replace.",
    C: "No.3 ﾀﾞｲﾊｲﾄ調整回数がC判定です。駆動部ｶﾞﾀ、ｷﾞﾔ歯面、接点など、点検をお勧めします。また、電磁開閉器の交換をお願いします。\nNo.3 Die Height Adjustment Activation Count is C.\nPlease inspect the ratting and the tooth plane of gear, the contact switch, etc.\nAnd please replace electromagnetic switch.",
  },
  clutchTime: {
    B: "No.4 クラッチ動作時間がB判定です。ｽﾄﾛｰｸ、圧力、電磁弁などの、注意観察をお願いします。\nNo.4 Clutch Operating Time is B. Please observe the stroke and the pressure , the solenoid valve ,etc.",
    C: "No.4 クラッチ動作時間がC判定です。ｽﾄﾛｰｸ、圧力、漏れ、電磁弁などの、点検・調整をお願いします。\nNo.4 Clutch Operating Time is C. Please inspect and adjust the stroke and the pressure , the solenoid valve ,etc.",
  },
  brakeTime: {
    B: "No.5 ブレーキ動作時間がB判定です。ｽﾄﾛｰｸ、圧力、電磁弁などの、注意観察をお願いします。\nNo.5 Brake Operating Time is B. Please observe the stroke and the pressure , the solenoid valve ,etc.",
    C: "No.5 ブレーキ動作時間がC判定です。ｽﾄﾛｰｸ、圧力、漏れ、電磁弁などの、点検・調整をお願いします。\nNo.5 Brake Operating Time is C. Please inspect and adjust the stroke and the pressure , the solenoid valve ,etc.",
  },
  microInching: {
    B: "No.7 ﾏｲｸﾛｲﾝﾁﾝｸﾞ回数 -マグネットSW起動回数がB判定です。\nギヤの摩耗、ブレーキ等の点検を推奨します。\nまた、電磁開閉器の交換を推奨します。\nNo.7 Micro-inching Activation Count is B.\nRecommend inspection of the gear abrasion and the brake , etc .\nAnd electromagnetic switch is recommended to replace.",
    C: "No.7 ﾏｲｸﾛｲﾝﾁﾝｸﾞ回数 -マグネットSW起動回数がC判定です。\nギヤの摩耗、ブレーキ等の点検をお願いします。\nまた、電磁開閉器の交換をお願いします。\nNo.7 Micro-inching Activation Count - Activation Count Of Magnet SW is C.\nPlease inspect the gear abrasion and the brake , etc .\nAnd please replace electromagnetic switch.",
  },
  pointLeak: {
    B: "No.6 ポイント漏れ状態(差圧) - {{partsJpn}}がB判定です。Oﾘﾝｸﾞの摩滅、OPVのｺﾞﾐ噛みなどの点検を推奨します。\nNo.6 Leakage State Of Points(Differential - Pressure) - {{partsEng}} is B.\nRecommend inspection of the abrasion of O-ring and biting OPV , etc.",
    C: "No.6 ポイント漏れ状態(差圧) - {{partsJpn}}がC判定です。Oﾘﾝｸﾞの摩滅、OPVのｺﾞﾐ噛みなどの点検をお願いします。\nNo.6 Leakage State Of Points (Differential - Pressure) - {{partsEng}} is C.\nPlease inspect the abrasion of O-ring and biting of OPV , etc.",
  },
  errors: {
    B: "{{kindsJpn}} - {{partsJpn}}がB判定です。{{diff}}回増加しています。点検を推奨します。\n続発する場合は、弊社ｻｰﾋﾞｽにご相談ください。\n{{kindsEng}} - {{partsEng}} is B. It has increased {{diff}} times. Inspection  recommend.\nIf the problem continues , Please contact HF service department.",
    C: "{{kindsJpn}} - {{partsJpn}}がC判定です。{{diff}}回増加しています。点検をお願いします。\n続発する場合は、弊社ｻｰﾋﾞｽにご相談ください。\n{{kindsEng}} - {{partsEng}} is C. It has increased {{diff}}times. Please inspect.\nIf the problem continues , Please contact HF service department.",
  },
};

// 診断カルテ - 所見欄項目名取得
export const getOtherReportKindName = (key, lang) => {
  const list = { ...otherReportKindsList };
  if (key && list[key][lang]) {
    return list[key][lang];
  }

  return null;
};

// 診断カルテ - 所見欄部品名取得
export const getOtherReportPartsName = (key, lang) => {
  const list = { ...otherReportPartsList };
  if (key && list[key][lang]) {
    return list[key][lang];
  }

  return null;
};

// 診断カルテ - 所見欄自動判定文取得
export const getOtherReportData = (key) => {
  const otherReport = { ...otherReportList };
  if (key && otherReport[key]) {
    return otherReport[key];
  }

  return null;
};

// 診断カルテ - 所見欄自動判定情報
export const otherReportInfo = {
  allA: true,
  existC: false,
  errorsCount: 100,
  judgeData: {},
};

// 診断カルテ - 非toLocalString版桁区切り(XX,XXX,XXX)
export const createGroupNumberString = (num) => {
  const str = num.toString();
  let result = "";
  let count = 0;
  let i = str.length - 1;

  for (; i >= 0; i--) {
    result = str[i] + result;
    count += 1;

    if (count % 3 === 0 && i !== 0) {
      result = `,${result}`;
    }
  }

  return result;
};

// 診断カルテ - 小数点あり桁区切り(X,XXX.XXXX)
export const formatDecimalNumber = (num, decimalPlaces) => {
  const str = num.toFixed(decimalPlaces);
  const parts = str.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];
  let result = "";
  let count = 0;
  let i = integerPart.length - 1;

  for (; i >= 0; i--) {
    result = integerPart[i] + result;
    count += 1;

    if (count % 3 === 0 && i !== 0) {
      result = `,${result}`;
    }
  }

  if (decimalPart) {
    result += `.${decimalPart}`;
  }

  return result;
};

// 診断カルテ - 備考欄閾値埋め込み処理
const replaceJudgeValue = (judgeData, judgeFormat, data) => {
  // インスタンス生成
  const values = ["", ""];

  // 日本語処理
  if (judgeData.grouping) {
    // 桁区切り
    values[languageType.ja] = data[languageType.ja].replace(
      "{{judgeA}}",
      createGroupNumberString(judgeFormat.lowerLimitA)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeB}}",
      createGroupNumberString(judgeFormat.lowerLimitB)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeC}}",
      createGroupNumberString(judgeFormat.lowerLimitC)
    );
  } else if (judgeData.decimal) {
    // 小数点あり
    values[languageType.ja] = data[languageType.ja].replace(
      "{{judgeA}}",
      formatDecimalNumber(judgeFormat.lowerLimitA, 1)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeB}}",
      formatDecimalNumber(judgeFormat.lowerLimitB, 1)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeC}}",
      formatDecimalNumber(judgeFormat.lowerLimitC, 1)
    );
  } else {
    values[languageType.ja] = data[languageType.ja].replace(
      "{{judgeA}}",
      String(judgeFormat.lowerLimitA)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeB}}",
      String(judgeFormat.lowerLimitB)
    );
    values[languageType.ja] = values[languageType.ja].replace(
      "{{judgeC}}",
      String(judgeFormat.lowerLimitC)
    );
  }

  // 英語処理
  if (judgeData.grouping) {
    // 桁区切り
    values[languageType.en] = data[languageType.en].replace(
      "{{judgeA}}",
      createGroupNumberString(judgeFormat.lowerLimitA)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeB}}",
      createGroupNumberString(judgeFormat.lowerLimitB)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeC}}",
      createGroupNumberString(judgeFormat.lowerLimitC)
    );
  } else if (judgeData.decimal) {
    // 小数点あり
    values[languageType.en] = data[languageType.en].replace(
      "{{judgeA}}",
      formatDecimalNumber(judgeFormat.lowerLimitA, 1)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeB}}",
      formatDecimalNumber(judgeFormat.lowerLimitB, 1)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeC}}",
      formatDecimalNumber(judgeFormat.lowerLimitC, 1)
    );
  } else {
    values[languageType.en] = data[languageType.en].replace(
      "{{judgeA}}",
      String(judgeFormat.lowerLimitA)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeB}}",
      String(judgeFormat.lowerLimitB)
    );
    values[languageType.en] = values[languageType.en].replace(
      "{{judgeC}}",
      String(judgeFormat.lowerLimitC)
    );
  }

  return values;
};

// 診断カルテ - 共通項目情報
export const reportCategoryALL = [
  {
    key: "shotCount",
    label: ["ショット数", "Shot Count"],
    align: "left",
    rowSpan: 2,
    colSpan: 1,
    explanation: descriptionList.shotCount.explanation,
    subTable: subTableType.none,
    item: [
      {
        key: "total",
        index: 100,
        label: ["総数", "Total Count"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "Shot"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "difference",
        index: 101,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "Shot"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "dieHeightRange",
    label: ["ダイハイト調整距離", "Die Height Adjustment Distance"],
    align: "left",
    rowSpan: 1,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.dieHeightRange,
      judgeDataALL.dieHeightRange.total,
      descriptionList.dieHeightRange.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "total",
        index: 200,
        label: ["HF点検後の調整距離", "Distance After HF Inspection"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["m", "m"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "dieHeightCount",
    label: ["ダイハイト調整回数", "Die Height Adjustment Activation Count"],
    align: "left",
    rowSpan: 2,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.dieHeightCount,
      judgeDataALL.dieHeightCount.descent,
      descriptionList.dieHeightCount.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rise",
        index: 300,
        label: ["上昇", "Up"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "descent",
        index: 301,
        label: ["下降", "Down"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
];

export const reportCategoryBL = [
  {
    key: "clutchTime",
    label: ["クラッチ動作時間", "Clutch Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.clutchTime,
      judgeDataBL.clutchTime.total,
      descriptionList.clutchTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 400,
        label: ["起動時間 A", "Start Time A"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "link",
        index: 401,
        label: ["連結時間 B", "Connect Time B"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 402,
        label: ["動作時間 (A+B)", "Operating Time (A+B)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 403,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 404,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "brakeTime",
    label: ["ブレーキ動作時間", "Brake Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.brakeTime,
      judgeDataBL.brakeTime.total,
      descriptionList.brakeTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 500,
        label: ["起動時間 C", "Start Time C"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "brake",
        index: 501,
        label: ["制動時間 D", "Brake Time D"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 502,
        label: ["動作時間 (C+D)", "Operating Time (C+D)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 503,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 504,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "pointLeak",
    label: [
      "ポイント漏れ状態\n(差圧)",
      "Leakage State Of Points\n(Differential - Pressure)",
    ],
    align: "left",
    rowSpan: 4,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.pointLeak,
      judgeDataALL.pointLeak.all,
      descriptionList.pointLeak.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rightFront",
        index: 600,
        label: ["右前", "Right Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        upload: true,
        autoJudge: true,
      },
      {
        key: "leftFront",
        index: 601,
        label: ["左前", "Left Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightRear",
        index: 602,
        label: ["右後", "Right Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftRear",
        index: 603,
        label: ["左後", "Left Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "cfErrorTemp",
    label: ["CF警告数\n(温度異常)\n", "CF Number Of Warnings\n(Temp. Fault)"],
    align: "left",
    rowSpan: 3,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.cfErrorTemp,
      judgeDataBL.cfErrorTemp.all,
      descriptionList.cfErrorTemp.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rollFeeder",
        index: 700,
        label: ["ロールフィーダ", "Roll Feeder"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "terminalFeeder",
        index: 701,
        label: ["端末フィーダ", "Coil End Feeder"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "other",
        index: 702,
        label: ["その他", "Other"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "cfErrorElect",
    label: [
      "CFサーボモータ\n電流RMS値\n設定値超過回数\n",
      "CF Servo Motor RMS\nCurrent Exceedance\nCount",
    ],
    align: "left",
    rowSpan: 3,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.cfErrorElect,
      judgeDataBL.cfErrorElect.all,
      descriptionList.cfErrorElect.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rollFeeder",
        index: 800,
        label: ["ロールフィーダ", "Roll Feeder"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "terminalFeeder",
        index: 801,
        label: ["端末フィーダ", "Coil End Feeder"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "other",
        index: 802,
        label: ["その他", "Other"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "plErrorTemp",
    label: ["PL警告数\n(温度異常)\n", "PL Number Of Warnings\n(Temp. Fault)"],
    align: "left",
    rowSpan: 3,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.plErrorTemp,
      judgeDataBL.plErrorTemp.all,
      descriptionList.plErrorTemp.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "blank",
        index: 900,
        label: ["ブランク材排出CV", "Blank Carry-out CV"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "piler",
        index: 901,
        label: ["パイラCV", "Piler CV"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "other",
        index: 902,
        label: ["その他", "Other"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "plErrorElect",
    label: [
      "PLサーボモータ\n電流RMS値\n設定値超過回数\n",
      "PL Servo Motor RMS\nCurrent Exceedance\nCount",
    ],
    align: "left",
    rowSpan: 3,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.plErrorElect,
      judgeDataBL.plErrorElect.all,
      descriptionList.plErrorElect.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "blank",
        index: 1000,
        label: ["ブランク材排出CV", "Blank Carry-out CV"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "piler",
        index: 1001,
        label: ["パイラCV", "Piler CV"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "other",
        index: 1002,
        label: ["その他", "Other"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "coilRange",
    label: ["コイル総通板長", "Total Length Of Coil Thread"],
    align: "left",
    rowSpan: 2,
    colSpan: 1,
    explanation: descriptionList.coilRange.explanation,
    subTable: subTableType.none,
    item: [
      {
        key: "total",
        index: 1100,
        label: ["総通板長", "Total Length"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["km", "km"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "difference",
        index: 1101,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["km", "km"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
];

export const reportCategoryTA = [
  {
    key: "clutchTime",
    label: ["クラッチ動作時間", "Clutch Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.clutchTime,
      judgeDataTA.clutchTime.total,
      descriptionList.clutchTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 400,
        label: ["起動時間 A", "Start Time A"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "link",
        index: 401,
        label: ["連結時間 B", "Connect Time B"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 402,
        label: ["動作時間 (A+B)", "Operating Time (A+B)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 403,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 404,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "brakeTime",
    label: ["ブレーキ動作時間", "Brake Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.brakeTime,
      judgeDataTA.brakeTime.total,
      descriptionList.brakeTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 500,
        label: ["起動時間 C", "Start Time C"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "brake",
        index: 501,
        label: ["制動時間 D", "Brake Time D"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 502,
        label: ["動作時間 (C+D)", "Operating Time (C+D)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 503,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 504,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "pointLeak",
    label: [
      "ポイント漏れ状態\n(差圧)",
      "Leakage State Of Points\n(Differential - Pressure)",
    ],
    align: "left",
    rowSpan: 4,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.pointLeak,
      judgeDataALL.pointLeak.all,
      descriptionList.pointLeak.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rightFront",
        index: 600,
        label: ["右前", "Right Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftFront",
        index: 601,
        label: ["左前", "Left Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightRear",
        index: 602,
        label: ["右後", "Right Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftRear",
        index: 603,
        label: ["左後", "Left Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "rbMalfunction",
    label: ["RB重故障回数\n", "Number Of RB Major Fault"],
    align: "left",
    rowSpan: 6,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.rbMalfunction,
      judgeDataTA.rbMalfunction.all,
      descriptionList.rbMalfunction.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "df",
        index: 700,
        label: ["DF RB", "DF RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "ld",
        index: 701,
        label: ["LD RB", "LD RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "no1",
        index: 702,
        label: ["No.1 RB", "No.1 RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "no2",
        index: 703,
        label: ["No.2 RB", "No.2 RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "no3",
        index: 704,
        label: ["No.3 RB", "No.3 RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "ul",
        index: 705,
        label: ["UL RB", "UL RB"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
];

export const reportCategoryTR = [
  {
    key: "clutchTime",
    label: ["クラッチ動作時間", "Clutch Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.clutchTime,
      judgeDataTR.clutchTime.total,
      descriptionList.clutchTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 400,
        label: ["起動時間 A", "Start Time A"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "link",
        index: 401,
        label: ["連結時間 B", "Connect Time B"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 402,
        label: ["動作時間 (A+B)", "Operating Time (A+B)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 403,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 404,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "brakeTime",
    label: ["ブレーキ動作時間", "Brake Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.brakeTime,
      judgeDataTR.brakeTime.total,
      descriptionList.brakeTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 500,
        label: ["起動時間 C", "Start Time C"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "brake",
        index: 501,
        label: ["制動時間 D", "Brake Time D"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 502,
        label: ["動作時間 (C+D)", "Operating Time (C+D)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 503,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 504,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "pointLeak",
    label: [
      "ポイント漏れ状態\n(差圧)",
      "Leakage State Of Points\n(Differential - Pressure)",
    ],
    align: "left",
    rowSpan: 4,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.pointLeak,
      judgeDataALL.pointLeak.all,
      descriptionList.pointLeak.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rightFront",
        index: 600,
        label: ["右前", "Right Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftFront",
        index: 601,
        label: ["左前", "Left Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightRear",
        index: 602,
        label: ["右後", "Right Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftRear",
        index: 603,
        label: ["左後", "Left Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorTemp",
    label: [
      "TR軸警告数\n(温度異常)\n",
      "TR Axis Number Of Warnings\n(Temp. Fault)",
    ],
    align: "left",
    rowSpan: 11,
    colSpan: 1,
    explanation: descriptionList.trErrorTemp.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontAmp",
        index: 700,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "frontLinear1",
        index: 701,
        label: ["前フィード リニア1", "Front Feed Linear1"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "frontLinear2",
        index: 702,
        label: ["前フィード リニア2", "Front Feed Linear2"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearAmp",
        index: 703,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "rearLinear1",
        index: 704,
        label: ["後フィード リニア1", "Rear Feed Linear1"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearLinear2",
        index: 705,
        label: ["後フィード リニア2", "Rear Feed Linear2"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftLift",
        index: 706,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 707,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 708,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 709,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 710,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorPosi",
    label: [
      "TR軸警告数\n(位置偏差)\n",
      "TR Axis Number Of Warnings\n(Position Deviation)",
    ],
    align: "left",
    rowSpan: 7,
    colSpan: 1,
    explanation: descriptionList.trErrorPosi.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontFeed",
        index: 800,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearFeed",
        index: 801,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftLift",
        index: 802,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 803,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 804,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 805,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 806,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorElect",
    label: [
      "TRサーボモータ\nピーク電流\n仕様上限 到達回数",
      "TR Servo Motor Peak Current Exceedance Count",
    ],
    align: "left",
    rowSpan: 7,
    colSpan: 1,
    explanation: descriptionList.trErrorElect.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontFeed",
        index: 900,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearFeed",
        index: 901,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftLift",
        index: 902,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 903,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 904,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 905,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 906,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
];

export const reportCategoryTS = [
  {
    key: "clutchTime",
    label: ["クラッチ動作時間", "Clutch Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.clutchTime,
      judgeDataTS.clutchTime.total,
      descriptionList.clutchTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 400,
        label: ["起動時間 A", "Start Time A"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "link",
        index: 401,
        label: ["連結時間 B", "Connect Time B"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 402,
        label: ["動作時間 (A+B)", "Operating Time (A+B)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 403,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 404,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "brakeTime",
    label: ["ブレーキ動作時間", "Brake Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.brakeTime,
      judgeDataTS.brakeTime.total,
      descriptionList.brakeTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 500,
        label: ["起動時間 C", "Start Time C"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "brake",
        index: 501,
        label: ["制動時間 D", "Brake Time D"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 502,
        label: ["動作時間 (C+D)", "Operating Time (C+D)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 503,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 504,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "pointLeak",
    label: [
      "ポイント漏れ状態\n(差圧)",
      "Leakage State Of Points\n(Differential - Pressure)",
    ],
    align: "left",
    rowSpan: 4,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.pointLeak,
      judgeDataALL.pointLeak.all,
      descriptionList.pointLeak.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rightFront",
        index: 600,
        label: ["右前", "Right Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftFront",
        index: 601,
        label: ["左前", "Left Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightRear",
        index: 602,
        label: ["右後", "Right Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftRear",
        index: 603,
        label: ["左後", "Left Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorTemp",
    label: [
      "TR軸警告数\n(温度異常)\n",
      "TR Axis Number Of Warnings\n(Temp. Fault)",
    ],
    align: "left",
    rowSpan: 11,
    colSpan: 1,
    explanation: descriptionList.trErrorTemp.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontAmp",
        index: 700,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "frontLinear1",
        index: 701,
        label: ["前フィード リニア1", "Front Feed Linear1"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "frontLinear2",
        index: 702,
        label: ["前フィード リニア2", "Front Feed Linear2"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "rearAmp",
        index: 703,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearLinear1",
        index: 704,
        label: ["後フィード リニア1", "Rear Feed Linear1"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "rearLinear2",
        index: 705,
        label: ["後フィード リニア2", "Rear Feed Linear2"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "leftLift",
        index: 706,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 707,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 708,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 709,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 710,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorPosi",
    label: [
      "TR軸警告数\n(位置偏差)\n",
      "TR Axis Number Of Warnings\n(Position Deviation)",
    ],
    align: "left",
    rowSpan: 7,
    colSpan: 1,
    explanation: descriptionList.trErrorPosi.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontFeed",
        index: 800,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearFeed",
        index: 801,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftLift",
        index: 802,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 803,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 804,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 805,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 806,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "trErrorElect",
    label: [
      "TRサーボモータ\nピーク電流\n仕様上限 到達回数\n",
      "TR Servo Motor Peak Current Exceedance Count",
    ],
    align: "left",
    rowSpan: 7,
    colSpan: 1,
    explanation: descriptionList.trErrorElect.explanation,
    subTable: subTableType.motor,
    item: [
      {
        key: "frontFeed",
        index: 900,
        label: ["前フィード", "Front Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rearFeed",
        index: 901,
        label: ["後フィード", "Rear Feed"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftLift",
        index: 902,
        label: ["左リフト", "Left Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightLift",
        index: 903,
        label: ["右リフト", "Right Lift"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftClamp",
        index: 904,
        label: ["左クランプ", "Left Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightClamp",
        index: 905,
        label: ["右クランプ", "Right Clamp"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "addAxis",
        index: 906,
        label: ["追加軸", "Additional Axis"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
];

export const reportCategoryTY = [
  {
    key: "clutchTime",
    label: ["クラッチ動作時間", "Clutch Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.clutchTime,
      judgeDataTY.clutchTime.total,
      descriptionList.clutchTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 400,
        label: ["起動時間 A", "Start Time A"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "link",
        index: 401,
        label: ["連結時間 B", "Connect Time B"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 402,
        label: ["動作時間 (A+B)", "Operating Time (A+B)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 403,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 404,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "brakeTime",
    label: ["ブレーキ動作時間", "Brake Operating Time"],
    align: "left",
    rowSpan: 5,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.brakeTime,
      judgeDataTY.brakeTime.total,
      descriptionList.brakeTime.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "start",
        index: 500,
        label: ["起動時間 C", "Start Time C"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "brake",
        index: 501,
        label: ["制動時間 D", "Brake Time D"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: false,
        upload: true,
      },
      {
        key: "total",
        index: 502,
        label: ["動作時間 (C+D)", "Operating Time (C+D)"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "difference",
        index: 503,
        label: ["前回との差", "Difference From Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["ms", "ms"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
      {
        key: "per",
        index: 504,
        label: ["前回との比率", "Ratio To Previous Value"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["%", "%"],
        judge: false,
        autoJudge: false,
        upload: false,
      },
    ],
  },
  {
    key: "pointLeak",
    label: [
      "ポイント漏れ状態\n(差圧)",
      "Leakage State Of Points\n(Differential - Pressure)",
    ],
    align: "left",
    rowSpan: 4,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.pointLeak,
      judgeDataALL.pointLeak.all,
      descriptionList.pointLeak.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "rightFront",
        index: 600,
        label: ["右前", "Right Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftFront",
        index: 601,
        label: ["左前", "Left Front"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "rightRear",
        index: 602,
        label: ["右後", "Right Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
      {
        key: "leftRear",
        index: 603,
        label: ["左後", "Left Rear"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["MPa", "MPa"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
  {
    key: "microInching",
    label: [
      "マイクロインチング\n起動回数",
      "Micro-inching Activation Count\n(※Dedicated drive type)",
    ],
    align: "left",
    rowSpan: 2,
    colSpan: 1,
    explanation: replaceJudgeValue(
      descriptionList.microInching,
      judgeDataTY.microInching.magnet,
      descriptionList.microInching.explanation
    ),
    subTable: subTableType.none,
    item: [
      {
        key: "total",
        index: 700,
        label: ["総起動回数", "Total Activation Count"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: false,
        autoJudge: false,
        upload: true,
      },
      {
        key: "magnet",
        index: 701,
        label: ["マグネットSW\n起動回数", "Activation Count Of Magnet SW"],
        align: "left",
        beforeUnit: ["", ""],
        unit: ["回", "times"],
        judge: true,
        autoJudge: true,
        upload: true,
      },
    ],
  },
];

export const getReportCategory = (type) => {
  let list = null;

  switch (type) {
    case pressType.BL:
      list = reportCategoryALL.concat(reportCategoryBL);
      break;
    case pressType.TA:
      list = reportCategoryALL.concat(reportCategoryTA);
      break;
    case pressType.TR:
      list = reportCategoryALL.concat(reportCategoryTR);
      break;
    case pressType.TS:
      list = reportCategoryALL.concat(reportCategoryTS);
      break;
    case pressType.TY:
      list = reportCategoryALL.concat(reportCategoryTY);
      break;
    default:
      list = null;
      break;
  }
  return list;
};

export const reportData = {
  // 拠点名
  office: "",
  // 日付
  date: "",
  // データ形式名
  __typename: "DiagnosticChartDataDaily",
  // データ作成日時
  createdAt: "",
  // データ更新日時
  updatedAt: "",
  // 作成日
  createdDay: "",
  // 会社名
  companyName: "",
  // 工番
  workNumber: "",
  // 機種
  model: "",
  // 使用年数
  useYears: "",
  // 機番
  modelNumber: "",
  // 納入日
  dueDate: "",
  // 反映済みフラグ
  creationResult: false,
  // ショット数(共通項目)
  shotCount: {
    // 総数
    total: { value: "", judge: "" },
    // 前回との差
    difference: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // ダイハイト調整距離(共通項目)
  dieHeightRange: {
    // HF点検後の調整距離
    total: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // ダイハイト調整回数(共通項目)
  dieHeightCount: {
    // 上昇 A
    rise: { value: "", judge: "" },
    // 下降 B
    descent: { value: "", judge: "" },
    // 合計
    total: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // クラッチ動作時間
  clutchTime: {
    // 起動時間 A
    start: { value: "", judge: "" },
    // 連結時間 B
    link: { value: "", judge: "" },
    // 動作時間 A+B
    total: { value: "", judge: "" },
    // 前回との差
    difference: { value: "", judge: "" },
    // 前回との比率
    per: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // ブレーキ動作時間
  brakeTime: {
    // 起動時間 A
    start: { value: "", judge: "" },
    // 制動時間 B
    brake: { value: "", judge: "" },
    // 動作時間 A+B
    total: { value: "", judge: "" },
    // 前回との差
    difference: { value: "", judge: "" },
    // 前回との比率
    per: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // ポイント漏れ状態
  pointLeak: {
    // 左前
    leftFront: { value: "", judge: "" },
    // 左後
    leftRear: { value: "", judge: "" },
    // 右前
    rightFront: { value: "", judge: "" },
    // 右後
    rightRear: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // CF警告数(温度異常)(BL項目)
  cfErrorTemp: {
    // ロールフィーダ
    rollFeeder: { value: "", judge: "", diff: "" },
    // 端末フィーダ
    terminalFeeder: { value: "", judge: "", diff: "" },
    // その他
    other: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // CFサーボモータ 電流RMS値 設定値超過回数(BL項目)
  cfErrorElect: {
    // ロールフィーダ
    rollFeeder: { value: "", judge: "", diff: "" },
    // 端末フィーダ
    terminalFeeder: { value: "", judge: "", diff: "" },
    // その他
    other: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // PL警告数(温度異常)(BL項目)
  plErrorTemp: {
    // ブランク材排出CV
    blank: { value: "", judge: "", diff: "" },
    // パイラCV
    piler: { value: "", judge: "", diff: "" },
    // その他
    other: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // PLサーボモータ 電流RMS値 設定値超過回数(BL項目)
  plErrorElect: {
    // ブランク材排出CV
    blank: { value: "", judge: "", diff: "" },
    // パイラCV
    piler: { value: "", judge: "", diff: "" },
    // その他
    other: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // コイル総通板長(BL項目)
  coilRange: {
    // 総通板長
    total: { value: "", judge: "" },
    // 前回との差
    difference: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // RB重故障回数(TA項目)
  rbMalfunction: {
    // DF RB
    df: { value: "", judge: "", diff: "" },
    // LD RB
    ld: { value: "", judge: "", diff: "" },
    // No.1 RB
    no1: { value: "", judge: "", diff: "" },
    // No.2 RB
    no2: { value: "", judge: "", diff: "" },
    // No.3 RB
    no3: { value: "", judge: "", diff: "" },
    // UL RB
    ul: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // TR軸警告数(温度異常)(TR項目)
  trErrorTemp: {
    // 前フィード
    frontAmp: { value: "", judge: "", diff: "" },
    // 前フィード リニア1
    frontLinear1: { value: "", judge: "", diff: "" },
    // 前フィード リニア2
    frontLinear2: { value: "", judge: "", diff: "" },
    // 後フィード
    rearAmp: { value: "", judge: "", diff: "" },
    // 後フィード リニア1
    rearLinear1: { value: "", judge: "", diff: "" },
    // 後フィード リニア2
    rearLinear2: { value: "", judge: "", diff: "" },
    // 左リフト
    leftLift: { value: "", judge: "", diff: "" },
    // 右リフト
    rightLift: { value: "", judge: "", diff: "" },
    // 左クランプ
    leftClamp: { value: "", judge: "", diff: "" },
    // 右クランプ
    rightClamp: { value: "", judge: "", diff: "" },
    // 追加軸
    addAxis: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // TR軸警告数(位置偏差)(TR項目)
  trErrorPosi: {
    // 前フィード
    frontFeed: { value: "", judge: "", diff: "" },
    // 後フィード
    rearFeed: { value: "", judge: "", diff: "" },
    // 左リフト
    leftLift: { value: "", judge: "", diff: "" },
    // 右リフト
    rightLift: { value: "", judge: "", diff: "" },
    // 左クランプ
    leftClamp: { value: "", judge: "", diff: "" },
    // 右クランプ
    rightClamp: { value: "", judge: "", diff: "" },
    // 追加軸
    addAxis: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // TRサーボモータ ピーク電流仕様上限 到達回数(TR項目)
  trErrorElect: {
    // 前フィード
    frontFeed: { value: "", judge: "", diff: "" },
    // 後フィード
    rearFeed: { value: "", judge: "", diff: "" },
    // 左リフト
    leftLift: { value: "", judge: "", diff: "" },
    // 右リフト
    rightLift: { value: "", judge: "", diff: "" },
    // 左クランプ
    leftClamp: { value: "", judge: "", diff: "" },
    // 右クランプ
    rightClamp: { value: "", judge: "", diff: "" },
    // 追加軸
    addAxis: { value: "", judge: "", diff: "" },
    // 備考
    note: "",
  },
  // マイクロインチング起動回数(TY項目)
  microInching: {
    // 総起動回数
    total: { value: "", judge: "" },
    // マグネットSW起動回数
    magnet: { value: "", judge: "" },
    // 備考
    note: "",
  },
  // その他、所見等
  other: "",
  // アクセス権
  accessGroups: [],
};
